var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23752 9.5625C7.23752 9.04473 7.65725 8.625 8.17502 8.625H15.675C16.1928 8.625 16.6125 9.04473 16.6125 9.5625C16.6125 10.0803 16.1928 10.5 15.675 10.5H8.17502C7.65725 10.5 7.23752 10.0803 7.23752 9.5625Z",
    fill: "#8896AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17502 12.375C7.65725 12.375 7.23752 12.7947 7.23752 13.3125C7.23752 13.8303 7.65725 14.25 8.17502 14.25H12.8625C13.3803 14.25 13.8 13.8303 13.8 13.3125C13.8 12.7947 13.3803 12.375 12.8625 12.375H8.17502Z",
    fill: "#8896AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55002 8.625C2.55002 5.5184 5.06842 3 8.17502 3H15.675C18.7816 3 21.3 5.5184 21.3 8.625V14.25C21.3 17.3566 18.7816 19.875 15.675 19.875H8.17502C7.95858 19.875 7.745 19.8628 7.53493 19.839L3.95265 21.886C3.32766 22.2431 2.55002 21.7919 2.55002 21.072V8.625ZM7.13688 17.9069L7.74596 17.9759C7.88611 17.9918 8.02924 18 8.17502 18H15.675C17.7461 18 19.425 16.3211 19.425 14.25V8.625C19.425 6.55393 17.7461 4.875 15.675 4.875H8.17502C6.10395 4.875 4.42502 6.55393 4.42502 8.625V19.4565L7.13688 17.9069Z",
    fill: "#8896AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.862bbd1a5d4f7fc9cc4c5c708dc93872.svg";
export { ForwardRef as ReactComponent };